Object.defineProperty(exports,"__esModule",{value:true});exports.KEYBOARD=void 0;var KEYBOARD={ESCAPE:27,ARROW_LEFT:37,ARROW_RIGHT:39,ESPACE:32,RETURN:13};exports.KEYBOARD=KEYBOARD;
//# sourceMappingURL=KEYBOARD.js.map